"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../../../colors");
var _tokens = _interopRequireDefault(require("../../../tokens"));
var Theme = {
  list: {
    backgroundColor: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.GREY_600
  },
  listItem: {
    highlightedColor: _tokens["default"].colors.hover,
    selectedColor: _tokens["default"].colors.selected,
    errorColor: _tokens["default"].colors.error
  }
};
var _default = Theme;
exports["default"] = _default;